import { defaultBTColor } from 'api/theme/colors';

const DEFAULT_DIRECTION = 'to bottom';

export const workflowTheme = ({
  palette: { primary, text },
  spacing: { unit },
  typography: {
    mainTitle,
    title: { fontFamily, fontWeight, fontWeightHeavy }
  },
  workflow: {
    header: {
      color: headerColor,
      direction: headerDirection = DEFAULT_DIRECTION,
      fontSize: headerFontSize,
      extraHeader = {},
      gradientEnd = defaultBTColor,
      gradientStart = defaultBTColor,
      height: headerHeight
    } = {}
  } = {}
}) => {
  const headerHeightNum = Math.max(+(headerHeight || '80').replace(/\D/gi, ''), 60);
  return {
    extraBox: {
      backgroundColor: extraHeader?.backgroundColor || primary.normal,
      color: extraHeader?.color || headerColor || text.light,
      amount: {
        fontFamily: mainTitle.fontFamily,
        fontSize: 0.35 * headerHeightNum,
        fontWeight: mainTitle.fontWeight
      },
      subtext: {
        fontFamily,
        fontSize: 0.175 * headerHeightNum,
        fontWeight: fontWeightHeavy,
        textTransform: 'uppercase'
      }
    },
    footer: {
      height: '300px',
      backgroundColor: '#fff',
      color: text.dark
    },
    header: {
      background: `linear-gradient(${headerDirection}, ${gradientStart}, ${gradientEnd})`,
      color: headerColor,
      headerHeightNum,
      height: `${headerHeightNum}px`,
      '& button.btn': {
        padding: 0
      }
    },
    title: {
      fontFamily: 'Barlow Condensed',
      fontSize: headerFontSize || `${0.35 * headerHeightNum}px`,
      fontSizeNum: 0.35 * headerHeightNum,
      fontWeight,
      margin: `0 ${unit}px`,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    wrapper: {
      padding: unit * 7.5
    }
  };
};

const styles = ({
  palette: { grey },
  spacing: { unit },
  workflow: {
    extraBox,
    footer,
    header,
    header: {
      backArrow: { color: backArrowColor } = {},
      color: headerColor,
      direction: headerDirection = DEFAULT_DIRECTION,
      gradientEnd = defaultBTColor,
      gradientStart = defaultBTColor,
      height: headerHeight,
      headerHeightNum
    } = {},
    title
  } = {}
}) => ({
  backArrow: {
    display: 'flex',
    width: unit * 7.25,
    alignItems: 'center',
    justifyContent: 'center',
    aspectRatio: 1,
    padding: 0,
    border: 0,
    '& svg': {
      fill: backArrowColor || headerColor,
      margin: 'auto',
      height: 0.2 * headerHeightNum,
      width: 0.2 * headerHeightNum
    }
  },
  extraBox: {
    ...extraBox,
    alignSelf: 'stretch',
    display: 'flex',
    padding: `0 ${unit * 4}px 0 ${unit * 3}px`
  },
  header: {
    ...header
  },
  footer: {
    ...footer
  },
  workflowHeader: {
    background: `linear-gradient(${headerDirection}, ${gradientStart}, ${gradientEnd})`,
    display: 'flex',
    alignItems: 'center',
    color: headerColor,
    height: headerHeight || 80,
    '& button.btn': {
      padding: 0
    },
    '& > *': {
      // fix hanging text getting chopped from overflow to enable ellipses test overflow
      paddingBottom: 2
    },
    '& button.btn-link': {
      background: 'none'
    }
  },
  workflowTitle: {
    ...title,
    flex: 2,
    lineHeight: 1
  },
  wrapper: {
    minHeight: `calc(100vh - ${headerHeight} - ${footer.height})`,
    '& .workflow-body': {
      padding: [unit * 3.75, unit * 5.5, unit * 5.5],
      overflow: 'auto'
    },

    '& .workflow-highlight': {
      '& + .workflow-body': {
        paddingTop: 0
      },
      backgroundColor: grey.G50,
      marginBottom: unit * 5,
      minHeight: unit * 19,
      overflow: 'auto',
      padding: `${unit * 7.5}px ${unit * 5.5}px`,
      paddingBottom: unit * 4
    },

    '& .workflow-footer': {
      ...footer,
      height: footer.height,
      padding: `${unit * 2}px ${unit * 7.5}px`,
      position: 'absolute',
      bottom: 0,
      width: '100%'
    }
  }
});

export default styles;
